<template>
	<div class="left_nav stream-left-panel">
		<div class="left_nav_items">

			<b-nav>
		  	<b-nav-item class="ace_sec_txt" aria-label="Progress View" v-if="isProgressViewEnabled" @click="navigateToProgressView()" :active="active === 'progress'">Progress View</b-nav-item>
		  	<b-nav-item class="ace_sec_txt" aria-label="Career View" v-if="isCareerViewEnabled" @click="navigateToCareerView()" :active="active === 'career'">Career View</b-nav-item>
		  	<b-nav-item class="ace_sec_txt" aria-label="Category View" v-if="isCategoryViewEnabled" @click="navigateToCategoryView()" :active="active === 'category'">Category View</b-nav-item>
		  	<b-nav-item class="ace_sec_txt" aria-label="Time View" v-if="isTimeViewEnabled" @click="navigateToTimeView()" :active="active === 'time'">Time View</b-nav-item>
        <b-nav-item class="ace_sec_txt" aria-label="plannerViewLabel" v-if="isPlannerViewEnabled" @click="navigateToPlannerView()" :active="active === 'planner'">{{plannerViewLabel}}</b-nav-item>
        <b-nav-item class="ace_sec_txt" aria-label="Reports" v-if="isReportsViewEnabled" @click="navigateToReport()" :active="active === 'report'">Reports</b-nav-item>
			</b-nav>

		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'

export default {
  name: 'streamMenu',
  props: ['uuid', 'active'],
  components: {
  },
  data: () => {
    return {
    }
  },

  mounted () {
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadLogDashboardActivity'
    ]),
    navigateToProgressView () {
      this.loadLogDashboardActivity({action: 'clickProgressView', page: this.active + 'View', link: 'Progress View', entityUuid: this.uuid})
      return this.$router.push({ name: 'streamProgress', params: { uuid: this.uuid } })
    },
    navigateToCareerView () {
      this.loadLogDashboardActivity({action: 'clickCareerView', page: this.active + 'View', link: 'Career View', entityUuid: this.uuid})
      return this.$router.push({ name: 'streamCareer', params: { uuid: this.uuid } })
    },
    navigateToCategoryView () {
      this.loadLogDashboardActivity({action: 'clickCategoryView', page: this.active + 'View', link: 'Category View', entityUuid: this.uuid})
      return this.$router.push({ name: 'streamCategory', params: { uuid: this.uuid } })
    },
    navigateToTimeView () {
      this.loadLogDashboardActivity({action: 'clickTimeView', page: this.active + 'View', link: 'Time View', entityUuid: this.uuid})
      return this.$router.push({ name: 'streamTime', params: { uuid: this.uuid } })
    },
    navigateToReport () {
      this.loadLogDashboardActivity({action: 'clickReportView', page: this.active + 'View', link: 'Reports', entityUuid: this.uuid})
      return this.$router.push({ name: 'streamReport', params: { uuid: this.uuid } })
    },
    navigateToPlannerView () {
      this.loadLogDashboardActivity({action: 'clickPlannerView', page: this.active + 'View', link: 'Planner View', entityUuid: this.uuid})
      return this.$router.push({ name: 'streamPlanner', params: { uuid: this.uuid } })
    }
  },

  computed: {
    ...mapState({
      'stream': state => state.stream.stream,
      'enabledFeatures': state => state.institution.enabledFeatures
    }),
    isCareerViewEnabled () {
      let skillTaggingFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SKILL_TAGGING_FEATURE_ID]
      if (skillTaggingFeature) {
        return skillTaggingFeature.enabled
      }
      return false
    },
    isPlannerViewEnabled () {
      let plannerViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PLANNER_VIEW_FEATURE_ID]
      if (plannerViewFeature && plannerViewFeature.enabled) {
        return true
      }
      return false
    },
    isTimeViewEnabled () {
      let timeViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.TIME_VIEW_FEATURE_ID]
      if (timeViewFeature && timeViewFeature.enabled) {
        return true
      }
      return false
    },
    isProgressViewEnabled () {
      let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
      if (progressViewFeature && progressViewFeature.enabled) {
        return true
      }
      return false
    },
    isReportsViewEnabled () {
      let reportsViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.REPORTS_VIEW_FEATURE_ID]
      if (reportsViewFeature && reportsViewFeature.enabled) {
        return true
      }
      return false
    },
    isCategoryViewEnabled () {
      let categoryViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CATEGORY_VIEW_FEATURE_ID]
      if (categoryViewFeature && categoryViewFeature.enabled) {
        return true
      }
      return false
    },
    plannerViewLabel () {
      let plannerViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PLANNER_VIEW_FEATURE_ID]
      if (!plannerViewFeature || !plannerViewFeature.enabled || !plannerViewFeature.label) {
        return 'Planner View'
      }
      return plannerViewFeature.label
    }
  },

  watch: {
  }
}
</script>
<style>
.stream-left-panel {
	.stream-left-panel {
		max-width:164px;
	}
}
</style>



// WEBPACK FOOTER //
// src/app/stream/components/StreamMenu.vue